import React from 'react';
import Button from '../../generic-components/Button';
import { ReactComponent as ArrowRightIcon } from '../../assets/icons/svg/shared/ic-shared-right-arrow.svg';
import { STYLES } from './consts';

interface IProps {
    icon: React.ReactNode;
    title: string;
    subTitle: string;
    actionType: string;
    onActionClick: (actionType: string) => void;
    badge?: React.ReactNode;
    disabled?: boolean
}

const StripAction = ({
  icon, title, subTitle, actionType, onActionClick, badge, disabled = false,
}:IProps) => (
  <div className={disabled ? STYLES.WRAPPER_DISABLED : STYLES.WRAPPER}>
    <Button
      className={disabled ? STYLES.BTN_CONTAINER_DISABLED : STYLES.BTN_CONTAINER}
      id={`strip-${actionType}`}
      onClick={() => {
        if (disabled) return;
        onActionClick(actionType);
      }}
      childElement={(
        <div className={STYLES.FLEX_CENTER}>
          <div className={STYLES.FLEX_CENTER}>
            {icon}
            <div className='flex flex-col text-left gap-[4px]'>
              <div className='flex items-center gap-[4px]'>
                <p className={STYLES.TITLE}>{title}</p>
                {badge}
              </div>
              <p className={STYLES.SUB_TITLE}>{subTitle}</p>
            </div>
          </div>
          <ArrowRightIcon className='w-[16px] text-bw07' />
        </div>
            )}
    />
  </div>
);

export default StripAction;
